<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 2376 2622"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g transform="matrix(1.00042,0,0,1.00079,-16.0007,1.51141)">
      <g id="subhoodie_3_back">
        <g
          id="primary-colour"
          transform="matrix(1.74603,0,0,1.76308,3061.63,-642.048)"
        >
          <path
            d="M-535.818,1100.55c-29.117,-77.9 -67.833,-174.343 -99.487,-223.697c-4.111,-6.41 -9.032,-11.356 -12.832,-16.059c-63.096,-59.59 -144.339,-87.293 -241.126,-101.805c13.808,-77.346 22.716,-148.177 13.587,-206.013c-10.782,-68.306 -44.582,-117.341 -87.842,-150.232c-55.332,-42.067 -111.632,-44.66 -144.822,-31.342c-38.54,15.466 -69.56,40.27 -94.04,71.864c-18.69,24.132 -34.2,51.985 -42.57,84.099c-17.15,65.774 -6.27,145.498 11.84,231.461c-127,22.765 -218.71,58.69 -258.39,104.706c-24.97,28.176 -62.95,122.549 -103.6,220.408l-78.54,209.42c-1.9,4.11 -3.82,8.24 -5.24,12.55c-3.71,11.23 -7.24,22.54 -10.13,34.01c-6.4,25.44 -8.32,53.22 -6.09,79.3c3.65,42.86 34.2,162.1 34.41,163.08c7.98,36.86 15.49,76.61 16.93,114.82c0.31,8.3 0.37,16.59 0.02,24.89c-0.6,14.43 4.58,22.66 14.14,31.61c8.39,7.87 15.37,24.39 23.75,40.07c6.08,11.38 13.19,22.57 18.74,34.22c-0,0 109.2,-26.42 134.58,-24.19c0.79,-1.21 1.62,-4 2.24,-5.31c1.51,-3.19 3.2,-6.34 4.17,-9.74c1.25,-4.41 2.03,-8.97 2.43,-13.53c0.77,-8.68 -4.61,-15.75 -5.03,-24.23c-0.54,-11.05 4.06,-21.75 5.87,-32.65c3.2,-19.32 6.32,-40.47 0.97,-59.81c-3.66,-13.21 -10.66,-24.53 -13.15,-38.27c-5.05,-27.92 -2.46,-28.06 -7.04,-56.28c-2.01,-12.34 -5.15,-16.84 -9.93,-28.49c-6.48,-15.82 -10.14,-31.72 -5.92,-48.77c1.34,-5.38 3.12,-10.64 5.01,-15.85c0.76,-2.08 1.84,-4.03 2.91,-5.97c1.82,-2.97 3.65,-5.96 4.93,-9.19c1.03,-2.61 1.58,-5.42 1.92,-8.21c0.82,-6.61 -6.61,-13.28 -8.91,-18.03c-1.4,-2.9 -0.5,-9.52 0.19,-12.01c1.44,-5.18 3.26,-10.25 5.24,-15.24c0.94,-2.38 2.23,-4.61 3.51,-6.83l70.982,-137.841c2.12,11.21 -0.732,22.171 -0.812,33.581c-0.15,20.73 -4.09,136.95 -4.38,148.67c-1.94,77.5 -3.85,155.33 0.97,232.78c2.17,34.65 4.64,70.99 14.78,104.45c3.05,10.07 8.78,27.57 19.5,34.05c15.35,9.29 38.65,12.79 55.48,16.3c25,5.22 50.61,9.31 75.95,12.23c52.66,6.05 105.7,8.24 158.68,6.6l2.28,0.07l2.28,-0.07c66.87,2.07 134.011,-1.76 200.082,-12.39c20.189,-3.25 41.632,-7.58 61.511,-12.83c5.48,-1.44 21.832,-5.93 28.523,-9.91c10.324,-6.14 16.322,-21.97 19.611,-31.81c10.183,-30.48 12.929,-63.95 15.218,-95.75c7.31,-101.54 1.986,-203.82 -1.306,-305.4c-0.806,-24.88 -3.642,-92.19 -2.294,-121.89l-0.001,0l0.016,-0.45l71.521,139.11c1.361,2.27 2.733,4.57 3.74,7.02c2.072,5.05 3.987,10.18 5.472,15.43c3.431,12.13 -5.649,15.43 -8.708,26.07c-1.108,3.86 0.14,8.67 1.5,12.08c1.265,3.16 3.092,6.09 4.9,8.98c1.087,2 2.183,4.02 2.955,6.17c1.924,5.35 3.748,10.75 5.116,16.27c4.275,17.23 0.808,33.34 -5.763,49.37c-4.243,10.36 -6.92,13.89 -8.87,24.77c-3.038,16.94 -3.749,34.23 -6.581,51.21c-3.743,22.43 -16.101,43.07 -17.895,65.77c-1.096,13.87 2.05,27.69 4.882,41.35c0.996,4.81 7.916,23.091 7.135,32.301c-0.716,8.43 -4.789,14.819 -3.917,23.529c0.454,4.53 0.018,9.61 1.334,13.97c1.017,3.37 1.365,6.41 2.934,9.56c0.644,1.29 2.54,4.73 3.359,5.92c25.375,-2.23 133.689,23.99 133.689,23.99c0,0 34.701,-64.8 38.942,-74.41c21.072,-15.9 15.509,-35.84 16.801,-57.04c0.509,-8.36 1.198,-16.72 2.158,-25.04c3.277,-28.44 10.204,-63.62 15.73,-89.54c11.556,-54.2 29.194,-107.54 34.03,-162.75c2.252,-25.72 0.518,-53.16 -5.754,-78.27c-2.802,-11.21 -6.255,-22.26 -9.878,-33.24c-1.382,-4.18 -3.255,-8.2 -5.12,-12.2l-73.48,-195.53Z"
            :style="{
              fill: productColors.primary_1.value,
              transition: 'all 500ms',
            }"
          />
        </g>
        <g transform="matrix(19.7139,0,0,21.094,3886.84,-24107.8)">
          <path
            d="M-137.584,1180.18l-29.275,0c0.299,-0.139 0.603,-0.279 0.91,-0.41l24.471,0c1.212,0.219 2.513,0.367 3.894,0.41Zm-7.698,-1.394l-18.195,0c0.394,-0.143 0.783,-0.279 1.173,-0.41l15.902,0c0.358,0.14 0.731,0.278 1.12,0.41Zm-3.314,-1.394l-10.49,0c0.541,-0.147 1.066,-0.283 1.574,-0.41l8.147,0c0.24,0.134 0.497,0.271 0.769,0.41Zm25.913,-0.41l7.439,0c0.509,0.127 1.033,0.263 1.574,0.41l-9.882,0c0.288,-0.131 0.578,-0.268 0.869,-0.41Zm-3.385,1.394l15.617,0c0.389,0.131 0.779,0.267 1.172,0.41l-17.982,0c0.394,-0.127 0.792,-0.263 1.193,-0.41Zm-5.274,1.394l24.539,0c0.304,0.131 0.607,0.271 0.911,0.41l-30.011,0c1.261,-0.039 3.191,-0.169 4.561,-0.41Zm-33.66,40.378l57.252,0c0.004,0.057 0.009,0.111 0.017,0.168c-0.004,0.078 -0.008,0.16 -0.008,0.242l-57.273,0c0,-0.082 -0.004,-0.164 -0.008,-0.242c0.008,-0.057 0.012,-0.111 0.02,-0.168Zm57.105,-0.984l-57.002,0l0,-0.41l57.002,0l0,0.41Zm-0.111,-1.394l-56.768,0l0,-0.41l56.768,0l0,0.41Zm-0.074,-1.39l-56.608,0l0,-0.41l56.608,0l0,0.41Zm-0.041,-1.394l-56.518,0l0,-0.41l56.518,0l0,0.41Zm-56.502,-1.799l56.498,0l0,0.41l-56.498,0l0,-0.41Zm-0.024,-1.394l56.551,0l0,0.41l-56.551,0l0,-0.41Zm-0.053,-1.394l56.474,0.01l-0,0.41l-56.474,-0.01l0,-0.41Zm-0.095,-1.39l56.581,0l0,0.41l-56.581,0l0,-0.41Zm-0.131,-1.394l56.851,0l0,0.41l-56.851,0l0,-0.41Zm-0.213,-1.324c-0.004,-0.025 -0.008,-0.045 -0.008,-0.07l57.253,0c-0.012,0.074 -0.021,0.148 -0.033,0.226l-0.025,0.184l-57.142,0c-0.012,-0.115 -0.029,-0.229 -0.045,-0.34Zm0.082,-1.05c-0.02,-0.135 -0.041,-0.274 -0.066,-0.41l57.36,0c-0.02,0.136 -0.045,0.275 -0.066,0.41l-57.228,0Zm-0.242,-1.394c-0.025,-0.139 -0.049,-0.274 -0.078,-0.409l57.872,0c-0.028,0.135 -0.053,0.27 -0.082,0.409l-57.712,0Zm-0.283,-1.389c-0.028,-0.14 -0.057,-0.275 -0.09,-0.41l58.463,0c-0.033,0.135 -0.062,0.27 -0.091,0.41l-58.282,0Zm-0.324,-1.394c-0.032,-0.14 -0.065,-0.275 -0.102,-0.41l58.983,0c-0.037,0.135 -0.074,0.27 -0.107,0.41l-58.774,0Zm-0.365,-1.394c-0.036,-0.14 -0.077,-0.275 -0.114,-0.41l59.737,0c-0.041,0.135 -0.078,0.27 -0.119,0.41l-59.504,0Zm-0.405,-1.39c-0.045,-0.139 -0.087,-0.275 -0.128,-0.41l60.57,0c-0.041,0.135 -0.082,0.271 -0.127,0.41l-60.315,0Zm-0.455,-1.394c-0.046,-0.139 -0.095,-0.274 -0.144,-0.41l61.537,0.002c-0.045,0.136 -0.094,0.271 -0.139,0.41l-61.254,-0.002Zm-0.402,-1.394c-0.053,-0.139 -0.102,-0.274 -0.155,-0.41l62.463,0.002c-0.054,0.136 -0.103,0.271 -0.156,0.41l-62.152,-0.002Zm-0.545,-1.389c-0.053,-0.14 -0.11,-0.275 -0.168,-0.41l63.609,0c-0.053,0.135 -0.11,0.274 -0.168,0.41l-63.273,0Zm-0.594,-1.394c-0.062,-0.14 -0.123,-0.275 -0.185,-0.41l64.835,0c-0.061,0.135 -0.123,0.27 -0.184,0.41l-64.466,0Zm-0.644,-1.39c-0.07,-0.14 -0.135,-0.275 -0.201,-0.41l66.159,0c-0.069,0.135 -0.135,0.27 -0.205,0.41l-65.753,0Zm-0.701,-1.394c-0.074,-0.139 -0.148,-0.275 -0.221,-0.41l67.603,0c-0.074,0.131 -0.148,0.271 -0.221,0.41l-67.161,0Zm-0.767,-1.394c-0.082,-0.143 -0.164,-0.279 -0.241,-0.41l69.177,0c-0.078,0.131 -0.16,0.267 -0.242,0.41l-68.694,0Zm-0.836,-1.39c-0.094,-0.143 -0.18,-0.279 -0.262,-0.41l70.895,0c-0.086,0.131 -0.172,0.267 -0.266,0.41l-70.367,0Zm-0.926,-1.394c-0.111,-0.155 -0.21,-0.291 -0.296,-0.41l72.814,0c-0.086,0.119 -0.188,0.255 -0.295,0.41l-72.223,0Zm72.567,-1.799c0.148,0.131 0.291,0.266 0.431,0.41l-73.987,0c0.139,-0.144 0.283,-0.279 0.43,-0.41l73.126,0Zm-1.742,-1.394c0.193,0.135 0.381,0.27 0.566,0.41l-70.874,0c0.184,-0.14 0.373,-0.279 0.566,-0.41l69.742,0Zm-2.239,-1.394c0.242,0.131 0.48,0.27 0.714,0.41l-66.255,0c0.233,-0.14 0.471,-0.279 0.713,-0.41l64.828,0Z"
            :style="`fill: url(#_Linear${id})`"
          />
        </g>
        <g id="colour-4" transform="matrix(20.8817,0,0,21.094,16104.3,-19735)">
          <path
            d="M-667.559,1002.08l-7.925,3.444l-0.766,-1.763l8.019,-3.485c0.233,0.619 0.459,1.222 0.672,1.804Zm-92.959,0.006c0.213,-0.582 0.439,-1.185 0.672,-1.804l8.019,3.485l-0.766,1.763l-7.925,-3.444Z"
            :style="{
              fill: productColors.primary_2.value,
              transition: 'all 500ms',
            }"
          />
        </g>
        <g
          id="teritiary-colour"
          transform="matrix(20.8817,0,0,21.094,16104.3,-19735)"
        >
          <path
            d="M-666.891,1003.89l-7.826,3.403l-0.767,-1.767l7.925,-3.444c0.233,0.627 0.459,1.234 0.668,1.808Zm-94.296,0.006c0.209,-0.574 0.435,-1.181 0.668,-1.808l7.925,3.444l-0.767,1.767l-7.826,-3.403Z"
            :style="{
              fill: productColors.secondary_1.value,
              transition: 'all 500ms',
            }"
          />
        </g>
        <rect
          id="logo-mask-1"
          x="716.231"
          y="589.85"
          width="946.655"
          height="1014.17"
          style="fill: none"
        />
        <use
          id="full-back-logo"
          :xlink:href="`#backFull${id}`"
          x="405"
          y="550"
          width="460px"
          height="514px"
          transform="matrix(1.71038,0,0,1.71038,503.522,577.002)"
        />
        <rect
          id="logo-mask-2"
          x="713.936"
          y="679.36"
          width="948.128"
          height="440.115"
          style="fill: none"
        />
        <use
          id="back-centre-logo"
          :xlink:href="`#backCenter${id}`"
          x="3755"
          y="4150"
          width="943px"
          height="306px"
          transform="matrix(1,0,0,1,-2558.56,-2895.51)"
        />
        <rect
          id="logo-mask-3"
          x="1074.65"
          y="264.884"
          width="236.764"
          height="124.687"
          style="fill: none"
        />
        <clipPath id="_clip3">
          <rect x="700" y="700" width="1000" height="800"></rect>
        </clipPath>
        <g clip-path="url(#_clip3)">
          <use
            id="under-back-logo"
            :xlink:href="`#backUpper${id}`"
            x="1570"
            y="1600"
            width="300px"
            height="136px"
            transform="matrix(0.794512,0,0,0.794512,-47.2027,-287.969)"
          />
        </g>
        <g
          v-if="activePlayer"
          id="number-mask"
          transform="matrix(0.750274,0,0,0.760397,307.43,540.724)"
        >
          <path
            d="M398.96,808.811l1586.84,0c-64.736,156.159 -68.501,372.244 -48.096,555.1c14.541,348.302 23.044,696.192 3.852,1042.19c-505.044,112.259 -1006.29,117.155 -1503.2,-0.223c-24.284,-326.074 -16.967,-679.609 -3.514,-1038.48c17.895,-163.915 18.407,-381.112 -35.888,-558.59Z"
            style="fill: none"
          />
          <clipPath id="_clip2">
            <path
              d="M398.96,808.811l1586.84,0c-64.736,156.159 -68.501,372.244 -48.096,555.1c14.541,348.302 23.044,696.192 3.852,1042.19c-505.044,112.259 -1006.29,117.155 -1503.2,-0.223c-24.284,-326.074 -16.967,-679.609 -3.514,-1038.48c17.895,-163.915 18.407,-381.112 -35.888,-558.59Z"
            />
          </clipPath>
          <g clip-path="url(#_clip2)">
            <g
              id="player-number"
              serif:id="player number"
              transform="matrix(0.997277,0,0,0.997277,569.2,1454.36)"
            >
              <text
                text-anchor="middle"
                x="600"
                :y="`${activePlayer.playerNumberBackVerticalPosition * 10}px`"
                :style="{
                  fontFamily: details.fontFamily,
                  fontSize: `${activePlayer.playerNumberBackSize * 10}px`,
                  fill: details.fontColor.value,
                }"
              >
                {{ activePlayer.number }}
              </text>
            </g>
          </g>
        </g>
        <g
          v-if="activePlayer"
          id="player-mask"
          transform="matrix(0.750274,0,0,0.760397,307.43,540.724)"
        >
          <path
            d="M2162.36,439.472c-106.072,-98.481 -243.675,-159.275 -562.246,-230.996c-136.407,85.466 -285.736,122.539 -410.898,121.811c-151.365,-10.453 -291.131,-36.509 -386.862,-121.811c-272.339,44.64 -467.952,122.395 -589.458,232.134c63.757,93.423 110.756,153.006 186.065,368.201l1580.15,0c32.045,-102.387 102.265,-272.989 183.251,-369.339Z"
            style="fill: none"
          />
          <clipPath id="_clip4">
            <path
              d="M2162.36,439.472c-106.072,-98.481 -243.675,-159.275 -562.246,-230.996c-136.407,85.466 -285.736,122.539 -410.898,121.811c-151.365,-10.453 -291.131,-36.509 -386.862,-121.811c-272.339,44.64 -467.952,122.395 -589.458,232.134c63.757,93.423 110.756,153.006 186.065,368.201l1580.15,0c32.045,-102.387 102.265,-272.989 183.251,-369.339Z"
            />
          </clipPath>
          <g clip-path="url(#_clip4)">
            <g
              id="player-name"
              serif:id="player name"
              transform="matrix(0.997277,0,0,0.997277,780.994,738.7)"
            >
              <text
                text-anchor="middle"
                x="400"
                :y="`${activePlayer.nameBackVerticalPosition * 2.42 - 176}`"
                :style="{
                  fontFamily: details.fontFamily,
                  fontSize: `${activePlayer.nameSize * 10}`,
                  fill: details.fontColor.value,
                  zIndex: 1000,
                }"
              >
                {{ activePlayer.name }}
              </text>
            </g>
          </g>
        </g>
        <g
          id="cheeta-logo"
          v-if="cheetaLogo.position === 'back'"
          transform="matrix(0.858343,0,0,0.858343,-132.098,180.225)"
        >
          <path
            d="M1498.79,799.4l7.078,0l0,20.005l5.927,0l0,-20.005l5.264,0l1.848,-5.204l-20.117,0l0,5.204Zm139.761,0l1.868,-5.204l-16.131,0l0,25.209l14.263,0l1.868,-5.211l-10.225,0l0,-4.967l7.318,0l1.787,-4.94l-9.105,0l0,-4.887l8.357,0Zm-117.035,19.979l14.263,0l1.901,-5.185l-10.257,0l0,-4.967l7.343,0l1.762,-4.94l-9.105,0l0,-4.887l8.356,0l1.901,-5.204l-16.164,0l0,25.183Zm77.562,-43.056l-21.395,0l0,-10.383l15.363,0l3.708,-10.31l-19.071,0l0,-10.258l17.495,0l3.9,-10.846l-33.738,0l0,52.67l29.838,0l3.9,-10.873Zm-42.731,-30.951l3.9,-10.846l-33.758,0l0,52.67l29.858,0l3.9,-10.873l-21.428,0l0,-10.383l15.389,0l3.715,-10.31l-19.104,0l0,-10.258l17.528,0Zm47.4,-10.846l0,10.846l14.799,0l0,41.824l12.416,0l0,-41.824l10.953,0l3.874,-10.846l-42.042,0Zm78.045,75.019c2.457,-1.364 3.761,-3.655 3.761,-7.099c0,-5.105 -3.198,-8.654 -10.012,-8.654c-3.073,0 -5.556,0.139 -8.357,0.457l0,25.156l5.9,0l0,-8.416l2.96,0l4.358,8.416l6.707,0l-5.317,-9.86Zm-6.675,-3.337l-2.033,0l0,-7.397c0.775,-0.132 1.629,-0.212 2.484,-0.212c2.589,0 3.734,1.47 3.734,3.761c0,2.57 -1.251,3.848 -4.185,3.848m-21.66,-12.681c-6.258,0 -9.701,3.284 -9.701,12.502l0,13.376l5.927,0l0,-6.893l7.588,0l0,6.893l5.874,0l0,-13.376c0,-9.218 -3.463,-12.502 -9.688,-12.502m3.814,14.151l-7.588,0l0,-2.033c0,-4.43 0.993,-6.728 3.774,-6.728c2.828,0 3.814,2.298 3.814,6.728l0,2.033Zm-42.969,1.741c0,3.709 -0.888,5.02 -2.483,5.02c-1.629,0 -2.517,-1.258 -2.517,-5.02l0,-15.223l-5.926,0l0,15.223c0,3.762 -0.908,5.02 -2.536,5.02c-1.577,0 -2.484,-1.311 -2.484,-5.02l0,-15.223l-5.926,0l0,14.369c0,7.953 2.483,11.449 7.926,11.449c3.02,0 4.788,-1.119 5.986,-3.066c1.146,1.947 2.907,3.066 5.953,3.066c5.45,0 7.967,-3.496 7.967,-11.449l0,-14.369l-5.96,0l0,15.223Zm-33.494,-15.223l-4.754,16.097l-4.702,-16.097l-6.542,0l-1.391,25.209l5.344,0l0.695,-14.369l4.305,14.369l4.509,0l4.324,-14.369l0.748,14.369l5.609,0l-1.331,-25.209l-6.814,0Zm-30.606,-0.669c-6.278,0 -9.721,3.284 -9.721,12.502l-0,13.376l5.927,0l-0,-6.867l7.615,0l-0,6.867l5.847,0l-0,-13.376c-0,-9.218 -3.444,-12.502 -9.668,-12.502m3.821,14.151l-7.615,0l-0,-2c-0,-4.463 0.993,-6.761 3.794,-6.761c2.827,0 3.821,2.298 3.821,6.761l-0,2Zm104.612,-34.825l15.939,0l-0,14.343l12.238,0l-0,-27.931c-0,-19.316 -7.238,-26.13 -20.244,-26.13c-13.111,0 -20.329,6.814 -20.329,26.13l-0,27.931l12.396,0l-0,-14.343Zm-0,-14.343c-0,-9.29 2.113,-14.124 7.933,-14.124c5.9,0 8.006,4.834 8.006,14.124l-0,4.198l-15.939,0l-0,-4.198Zm-151.489,-4.218l-15.435,0l-0,-19.766l-12.33,0l-0,52.67l12.33,0l-0,-21.501l15.435,0l-0,21.501l12.397,0l-0,-52.67l-12.397,0l-0,19.766Zm-50.551,23.607c-6.807,0 -8.973,-6.595 -8.973,-16.985c-0,-10.761 2.563,-16.906 8.84,-16.906c3.954,0 7.291,2.404 8.516,8.761l10.337,-6.595c-2.106,-8.357 -8.549,-13.039 -19.011,-13.039c-13.039,0 -21.588,7.827 -21.588,27.779c-0,21.342 9.781,27.699 21.746,27.699c7.986,0 15.509,-2.728 18.985,-12.793l-10.469,-6.602c-1.629,6.357 -4.807,8.681 -8.383,8.681"
            :style="{
              fill: cheetaLogo.color.value,
              transition: 'all 500ms',
              fillRule: 'nonzero',
            }"
          />
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        :id="`_Linear${id}`"
        x1="0"
        y1="0"
        x2="1"
        y2="-0.0189015"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0.971868,-31.7815,33.5923,0.310762,-132.893,1222.21)"
      >
        <stop offset="0" style="stop-color: #41484f; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #989898; stop-opacity: 1" />
      </linearGradient>
      <BackLogoImages :logos="{ backFullLogo, backUpperLogo }" :id="id" />

      <svg:style>
        {{ fontFace }}
      </svg:style>
    </defs>
  </svg>
</template>

<script>
import { getFontFace } from "@/assets/fonts/fontsBase64";
import { computed } from "vue";
import BackLogoImages from "@/components/SVGImagesAsComponents/Common/BackLogoImages";
export default {
  name: "SubHoodie_5_back",
  components: { BackLogoImages },
  props: ["productColors", "logo", "activePlayer", "cheetaLogo", "details"],
  setup(props) {
    const id = Math.floor(Math.random() * 10000).toString();
    const fontFace = computed(() => getFontFace(props.details.fontFamily));

    const backFullLogo = computed(() => props.logo.backFull);
    const backCenterLogo = computed(() => props.logo.backCenter);
    const backUpperLogo = computed(() => props.logo.backUpper);

    return {
      id,
      fontFace,
      backFullLogo,
      backCenterLogo,
      backUpperLogo,
    };
  },
};
</script>
